// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the ApiServices.tst template. 
// !!Do not modify this file or change may be lost!!
/* eslint-disable */
import BaseApi from './BaseApi';
import AuditorDTO from '../models/AuditorDTO';

export class AuditorApiService extends BaseApi {

  // get: api/auditor/auditors
  public getAuditors(): Promise<AuditorDTO[]> {
    let url = `api/auditor/auditors`;

    url = url.replace(/null|undefined/gi, '');
    return this.SendRequest<any, AuditorDTO[]>(null, 'get', url, true, false);
  }

  // get: api/auditor/auditors/${encodeURIComponent(committeeId)}
  public getAuditorByCommitteeId(committeeId: string): Promise<AuditorDTO> {
    let url = `api/auditor/auditors/${encodeURIComponent(committeeId)}`;

    url = url.replace(/null|undefined/gi, '');
    return this.SendRequest<any, AuditorDTO>(null, 'get', url, true, false);
  }

  // put: api/auditor?committeeId=${encodeURIComponent(committeeId)}&auditorId=${auditorId}
  public editCommitteeAuditor(committeeId: string, auditorId: number): Promise<void> {
    let url = `api/auditor`;
    let prefix = url.indexOf('?') > 0 ? '&' : '?';
    if (committeeId != null) {
      url += `${prefix}committeeId=${encodeURIComponent(committeeId)}`;
      prefix = '&';
    }
    if (auditorId != null) {
      url += `${prefix}auditorId=${auditorId}`;
      prefix = '&';
    }

    url = url.replace(/null|undefined/gi, '');
    return this.SendRequest<any, void>(null, 'put', url, true, false);
  }
}
var service = new AuditorApiService();
export default service;
